import { IModelProperty } from "@/utils/models/model-field";

export enum CalculatedFieldReturnType {
	BOOL = "boolean",
	NUMBER = "number",
	STRING = "string",
	DATE = "date",
	DURATION = "duration",
}

// In case running inside a browse
const GET_VALUE_FUNC_PRE_PROCESSOR = `
if (this && typeof(this.property) == "string" && typeof(this.name) == "string"){
	let pathParts = this.property.split(".");
	pathParts.pop();
	for (let part of pathParts) {
		if (val == null) {
			return "";
		}
		val = val[part];
	}
	if (!val) return "";
}
`;



export class CalculatedField {
	ID:number = 0;
	Table:string = "";
	Name:string = "";
	JsCode:string = "";
	ReturnType:CalculatedFieldReturnType = CalculatedFieldReturnType.BOOL;
	Preloads:string[] = [];
	DisplayOrder:number = 0;

	public constructor(data:any){
		this.ID = data.ID;
		this.Table = data.Table;
		this.Name = data.Name;
		this.JsCode = data.JsCode;
		this.ReturnType = data.ReturnType;
		this.Preloads = [...(data.Preloads || [])];
		this.DisplayOrder = 0;
	}

	public toModelProperty():IModelProperty{
		return {
			type: this.ReturnType,
			modelName: this.Table,
			isComputed: true,
			filterOnly: false,
			rightAlign: this.ReturnType == CalculatedFieldReturnType.NUMBER,
			dependencies: this.Preloads,
			getTranslatedName: ()=>this.Name,
			notFilterable: true,
			isCalculatedField: true,
			getValueFunc: new Function("val", `${GET_VALUE_FUNC_PRE_PROCESSOR}\n${this.JsCode}`) as (this:any)=>any,
		};
	}

}
